import { SupplierServicesUI } from "./SupplierServicesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { isSupplierDirect } from "../../utils/product/isSupplierDirect";
import { Product } from "../../types/types";

const getSellingProductType = (product: Product): boolean =>
  [
    "Cookers",
    "Dishwashers",
    "Freezers",
    "Fridge Freezers",
    "Fridges",
    "Hobs",
    "Laptops",
    "Microwaves",
    "Oven Warming Drawers",
    "Ovens",
    "Tumble Dryers",
    "Washer Dryers",
    "Washing Machines",
  ].includes(product?.sellingProductType ?? "");

export function SupplierServices({ product }: Pick<StandardProps, "product">) {
  const {
    variant: { availability, services },
  } = useVariant(product);

  function isDeliveryServiceAvailable(): boolean {
    return (
      (services &&
        services.some(({ __typename }) => __typename === "DeliveryService")) ||
      false
    );
  }

  const shouldShowForProductType = getSellingProductType(product);

  const shouldDisplaySupplierServices =
    isSupplierDirect(product) &&
    availability?.availableToOrder &&
    !isDeliveryServiceAvailable() &&
    shouldShowForProductType;

  if (shouldDisplaySupplierServices) {
    return <SupplierServicesUI />;
  }

  return null;
}
